import { Injectable, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly TOKEN_KEY = 'auth_token';
  private readonly ROLES_KEY = 'auth_roles';
  private readonly USER_KEY = 'auth_user';

  private rolesSubject = new BehaviorSubject<string[]>([]);
  roles$ = this.rolesSubject.asObservable();
  rolesSignal = signal<string[]>([]);
  userSignal = signal<{ nombre: string; apellido: string } | null>(null);

  constructor() {
    if (this.hasToken()) {
      const stored = localStorage.getItem(this.ROLES_KEY);

      if (stored) {
        try {
          const roles = JSON.parse(stored) as string[];
          this.rolesSubject.next(roles);
          this.rolesSignal.set(roles);
        } catch {
          localStorage.removeItem(this.ROLES_KEY);
        }
      }

      const storedUser = localStorage.getItem(this.USER_KEY);
      if (storedUser) {
        try {
          this.userSignal.set(JSON.parse(storedUser));
        } catch {
          localStorage.removeItem(this.USER_KEY);
        }
      }
    }
  }

  setToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  clearToken(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  hasToken(): boolean {
    return !!this.getToken();
  }

  setRoles(roles: string[]): void {
    localStorage.setItem(this.ROLES_KEY, JSON.stringify(roles));
    this.rolesSubject.next(roles);
    this.rolesSignal.set(roles);
  }

  getRoles(): string[] {
    return this.rolesSubject.getValue();
  }

  hasRole(role: string): boolean {
    return this.getRoles().includes(role);
  }

  clearRoles(): void {
    localStorage.removeItem(this.ROLES_KEY);
    this.rolesSubject.next([]);
    this.rolesSignal.set([]);
  }

  setUser(user: { nombre: string; apellido: string }): void {
    localStorage.setItem(this.USER_KEY, JSON.stringify(user));
    this.userSignal.set(user);
  }

  getUser(): { nombre: string; apellido: string } | null {
    return this.userSignal();
  }

  clearUser(): void {
    localStorage.removeItem(this.USER_KEY);
    this.userSignal.set(null);
  }
}
